import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Flex } from '@chakra-ui/react';
import BEButton from '@molecules/Button/Button';
import Text from '@molecules/Text';

interface RedirectNoticeProps {
  seconds: number;
  url: string;
}

const RedirectNotice = ({ seconds, url }: RedirectNoticeProps) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(seconds);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((previousTime) => previousTime - 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (countdown === 0 && isVisible) {
      handleRedirect();
    }
  }, [countdown, isVisible]);

  function handleRedirectDismissal() {
    setIsVisible(false);
  }

  function handleRedirect() {
    window.location.href = url;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <RedirectNotificationBox>
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="space-around"
        gap="10px"
      >
        <Text>{t('reservation-confirmation-reservation-complete')}</Text>
        <Text>{t('reservation-confirmation-redirection-notice')}</Text>
        <Text type="h2">
          {countdown} {countdown === 1 ? t('second') : t('seconds')}
        </Text>
        <Flex gap="15px">
          <BEButton
            color="primary"
            variant="outline"
            onClick={handleRedirectDismissal}
          >
            {t('reservation-confirmation-stay-on-page')}
          </BEButton>
          <BEButton color="primary" onClick={handleRedirect}>
            {t('reservation-confirmation-go-there-now')}
          </BEButton>
        </Flex>
      </Flex>
    </RedirectNotificationBox>
  );
};

const RedirectNotificationBox = styled.div`
  border: 2px solid #32C0A0;
  border-radius: 16px;
  width: 100%
  height: 200px;
  background-color: rgba(50, 192, 160, .05);
  padding: 20px;
`;

export default RedirectNotice;
